import React, { useEffect, useState } from 'react'
import { Card, CardBody, Col, Label, Modal, ModalBody, ModalHeader, Row, Table } from 'reactstrap'
import useApi from 'common/ApiMiddlewere'
import toast from 'react-hot-toast'
import { GetObjByHandWorkCostingStatus, GetObjByHandWorkOrderStatus } from '_mock/Static_data'
import { dateFormat } from 'pages/Common'

const HandWorkOrderAllDetailModel = ({ modal, toggle, handWorkOrderId }) => {
    const { getApi } = useApi()
    const [handworkOrderData, setHandWorkOrderData] = useState([])
    const [handworkData, setHandWorkData] = useState([])

    useEffect(() => {
        if (handWorkOrderId > 0) {
            getApi(`HandWorkOrder/details?id=${handWorkOrderId}`).then(({ data, status }) => {
                if (status === 200) {
                    setHandWorkOrderData(data?.HandWorkOrderDetail)
                    setHandWorkData(data?.HandWorkDetail)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
            })
        }
    }, [modal])

    return (
        <Modal isOpen={modal} toggle={toggle} centered={true} size="xl" style={{ width: "" }}>
            <div className="modal-content">
                <ModalHeader className="text-centre" toggle={toggle} tag="h5">
                    <span style={{ fontWeight: "600", fontSize: "20px", marginLeft: "8px" }}>Hand Work Order Details </span>
                </ModalHeader>
                <ModalBody>
                    <React.Fragment>
                        <Row>
                            <Col lg="12">
                                <Card>
                                    <CardBody className="p-1">
                                        <Row>
                                            <Col sm="5" className="text-sm-start">
                                                <address style={{ marginBottom: "4px" }}>
                                                    <span style={{ fontSize: "15px", fontWeight: "600" }}>
                                                        Name: </span>
                                                    <span style={{ fontSize: "14px" }}>
                                                        {handworkOrderData?.Name}
                                                    </span>
                                                </address>
                                            </Col>
                                            <Col sm="7" className="text-end">
                                                <address style={{ marginBottom: "4px" }}>
                                                    <span style={{ fontSize: "15px", fontWeight: "600" }}>
                                                        Unique No.: </span>
                                                    <span style={{ fontSize: "14px" }}>
                                                        {handworkOrderData?.UniqueNo}
                                                    </span>
                                                </address>

                                            </Col>
                                        </Row>
                                        <Row>
                                            {/* <Col sm="5" className="text-sm-start">
                                                <address style={{ marginBottom: "4px" }}>
                                                    <span style={{ fontSize: "15px", fontWeight: "600" }}>
                                                        Order No.: </span>
                                                    <span style={{ fontSize: "14px" }}>
                                                        {handworkOrderData?.OrderNo}
                                                    </span>
                                                </address>
                                            </Col> */}
                                            <Col sm="5" className="text-sm-start">
                                                <address style={{ marginBottom: "4px" }}>
                                                    <span style={{ fontSize: "15px", fontWeight: "600" }}>
                                                        Details: </span>
                                                    <span style={{ fontSize: "14px" }}>
                                                        {handworkOrderData?.Details}
                                                    </span>
                                                </address>
                                            </Col>
                                            <Col sm="7" className="text-sm-end">
                                                <address style={{ marginBottom: "4px" }}>
                                                    <span style={{ fontSize: "15px", fontWeight: "600" }}>
                                                        Order No.: </span>
                                                    <span style={{ fontSize: "14px" }}>
                                                        {handworkOrderData?.OrderNo}
                                                    </span>
                                                </address>
                                            </Col>
                                        </Row>
                                        <Row>

                                            <Col sm="5" className="text-start">
                                                <address className="mb-0">
                                                    <span style={{ fontSize: "16px", fontWeight: "600" }}>
                                                        Required  Date: </span>
                                                    <span style={{ fontSize: "14px" }}>
                                                        {dateFormat(handworkOrderData?.RequiredDate?.split("T")[0], "dd-MM-yyyy")}</span>
                                                    <br />
                                                </address>
                                            </Col>
                                            <Col sm="7" className="text-end">
                                                <address className="mb-0">
                                                    <span style={{ fontSize: "16px", fontWeight: "600" }}>
                                                        Created: </span>
                                                    <span style={{ fontSize: "14px" }}>
                                                        {dateFormat(handworkOrderData?.CreatedOn?.split("T")[0], "dd-MM-yyyy")}</span>
                                                    <br />
                                                </address>
                                            </Col>

                                        </Row>
                                        <div className="table-responsive">
                                            <Table className="table-nowrap" bordered>
                                                <thead>
                                                    <tr>
                                                        <th className="custom-header-invoice" style={{ width: "20px" }}>No</th>
                                                        <th className="custom-header-invoice" style={{ width: "20px" }}>Category</th>
                                                        <th className="custom-header-invoice" style={{ width: "20px" }}>Stitching Master</th>
                                                        <th className="custom-header-invoice" style={{ width: "100%" }}>Stitching Worker</th>
                                                        <th className="custom-header-invoice" style={{ width: "40px" }}>Stuff Details</th>
                                                        <th className="custom-header-invoice" style={{ width: "40px" }}>Worker Cost</th>
                                                        <th className="custom-header-invoice" style={{ width: "40px" }}>Material Cost</th>
                                                        <th className="custom-header-invoice" style={{ width: "40px" }}>Other Cost</th>
                                                        <th className="custom-header-invoice" style={{ width: "40px" }}>Costing</th>
                                                        <th className="custom-header-invoice" style={{ width: "40px" }}>Status</th>
                                                        <th className="custom-header-invoice" style={{ width: "40px" }}>Created</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {handworkData?.length == 0 ?
                                                        <tr>
                                                            <td style={{ textAlign: "center", fontSize: "15px" }} colSpan={11}>
                                                                No Worker
                                                            </td>
                                                        </tr>
                                                        :
                                                        handworkData?.map((item, index) => (
                                                            <tr key={item.Id || index}>
                                                                <td className='custom-header1'>{index + 1}</td>
                                                                <td className='custom-header1'>{item?.CategoryName || "N/A"}</td>
                                                                <td className='custom-header1'>{item?.StitchingMasterByName || "N/A"}</td>
                                                                <td className='custom-header1'>{item?.StitchingWorkerByName || "N/A"}</td>
                                                                <td className='custom-header1'>
                                                                    {item?.StuffDetails || "N/A"}
                                                                </td>
                                                                <td className='custom-header1'>
                                                                    <i className="mdi mdi-currency-inr"></i>
                                                                    {new Intl.NumberFormat('en-IN', {
                                                                        currency: 'INR',
                                                                        minimumFractionDigits: 2,
                                                                    }).format(item?.WorkerCost || 0)}
                                                                </td>
                                                                <td className='custom-header1'>
                                                                    <i className="mdi mdi-currency-inr"></i>
                                                                    {new Intl.NumberFormat('en-IN', {
                                                                        currency: 'INR',
                                                                        minimumFractionDigits: 2,
                                                                    }).format(item?.MaterialCost || 0)}
                                                                </td>
                                                                <td className='custom-header1'>
                                                                    <i className="mdi mdi-currency-inr"></i>
                                                                    {new Intl.NumberFormat('en-IN', {
                                                                        currency: 'INR',
                                                                        minimumFractionDigits: 2,
                                                                    }).format(item?.OtherCost || 0)}
                                                                </td>
                                                                <td className='custom-header1'>
                                                                    <i className="mdi mdi-currency-inr"></i>
                                                                    {new Intl.NumberFormat('en-IN', {
                                                                        currency: 'INR',
                                                                        minimumFractionDigits: 2,
                                                                    }).format(item?.Costing || 0)}
                                                                </td>
                                                                <td className='custom-header1'>
                                                                    {GetObjByHandWorkOrderStatus(item.Status)[0]?.Key || "0.00"}
                                                                </td>
                                                                <td className='custom-header1'>
                                                                    {dateFormat(item?.CreatedOn?.split("T")[0], "dd-MM-yyyy")}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </React.Fragment >
                </ModalBody>
            </div>
        </Modal >
    )
}

export default HandWorkOrderAllDetailModel